import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';
import './game/home-runtime-art.css';
import './decode-material.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Application root is missing');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
